import { render } from "./CouponsQuantity.vue?vue&type=template&id=685610b8&scoped=true"
import script from "./CouponsQuantity.vue?vue&type=script&lang=js"
export * from "./CouponsQuantity.vue?vue&type=script&lang=js"

import "./CouponsQuantity.vue?vue&type=style&index=0&id=685610b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685610b8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
